import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import WholesalePage from "@/pages/WholesalePage";
import BlogPage from "@/pages/BlogPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import ContactPage from "@/pages/ContactPage";
import CartPage from "@/pages/CartPage";

// Context
import { CartProvider } from "@/context/CartContext";

// Layout
import Layout from "@/components/Layout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  // Seed database on first load
  useEffect(() => {
    const seedDatabase = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        // Database might already be seeded
        console.log("Database seeding skipped or already done");
      }
    };
    seedDatabase();
  }, []);

  return (
    <CartProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/urunler" element={<ProductsPage />} />
            <Route path="/urunler/:slug" element={<ProductDetailPage />} />
            <Route path="/toptan-satis" element={<WholesalePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/sepet" element={<CartPage />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
